import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

export type InvestmentReasonMode = "reject" | "needsRevision";

interface InvestmentsReasonDialogProps {
  open: boolean;
  mode: InvestmentReasonMode;
  title?: string;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (rejectionReason: string) => void;
}

const MODE_COPY: Record<
  InvestmentReasonMode,
  { dialogTitle: string; submitLabel: string; helper: string }
> = {
  reject: {
    dialogTitle: "Отклонить заявку",
    submitLabel: "Отклонить",
    helper: "Заявка будет отклонена окончательно. Укажите причину.",
  },
  needsRevision: {
    dialogTitle: "Отправить на доработку",
    submitLabel: "На доработку",
    helper: "Резидент сможет отредактировать заявку и отправить повторно.",
  },
};

export const InvestmentsReasonDialog = ({
  open,
  mode,
  title,
  isSubmitting,
  onClose,
  onSubmit,
}: InvestmentsReasonDialogProps) => {
  const [reason, setReason] = useState("");
  const copy = MODE_COPY[mode];

  useEffect(() => {
    if (!open) setReason("");
  }, [open]);

  const handleSubmit = () => {
    const rejectionReason = reason.trim();
    if (!rejectionReason) {
      alert("Укажите причину");
      return;
    }
    onSubmit(rejectionReason);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{copy.dialogTitle}</DialogTitle>
      <DialogContent>
        {title && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {title}
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {copy.helper}
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          label="Причина *"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting}>
          Отмена
        </Button>
        <Button
          variant="contained"
          color={mode === "reject" ? "error" : "warning"}
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {copy.submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
